import React from "react";
import TableEditable from "../TableEditable";

const Headers = ({ updateData, data }) => {
  return <TableEditable updateData={updateData} type="HEADERS" data={data} />;
};
export default Headers;
